module.exports = __webpack_public_path__ + "img/page-img-round.93e78b9f.png";